import {MERCHANT_STORAGE_KEY_PREFIX} from "../../Constants";

interface StorageLike {
    getItem(key: string): string | null;
    setItem(key: string, value: string): void;
    removeItem(key: string): void;
}

export class MerchantStorage {
    getStorage: () => StorageLike;

    constructor(getStorage: () => StorageLike) {
        this.getStorage = getStorage;
    }

    getItem(key: string): any {
        try {
            let value = this.getStorage().getItem(MERCHANT_STORAGE_KEY_PREFIX + key);
            return JSON.parse(value);
        } catch (e) {
            return null;
        }
    }

    setItem(key: string, value: any): void {
        try {
            value = JSON.stringify(value);
            this.getStorage().setItem(MERCHANT_STORAGE_KEY_PREFIX + key, value);
        } catch (e) {
        }
    }

    removeItem(key: string): void {
        try {
            this.getStorage().removeItem(MERCHANT_STORAGE_KEY_PREFIX + key);
        } catch (e) {
        }
    }
}

export const merchantLocalStorage = new MerchantStorage(() => window.localStorage);
export const merchantSessionStorage = new MerchantStorage(() => window.sessionStorage);

const memoryStorageImpl = {
    items: new Map<string, string>(),
    getItem: (key: string) => memoryStorageImpl.items.get(key),
    setItem: (key: string, value: string) => memoryStorageImpl.items.set(key, value),
    removeItem: (key: string) => memoryStorageImpl.items.delete(key),
};
export const memoryStorage = new MerchantStorage(() => memoryStorageImpl);

export const StorageScope = {
    PERMANENT: "permanent",
    TAB: "tab",
    MEMORY: "memory",
};

export function getStorage(scope: string): MerchantStorage {
    if (scope === StorageScope.PERMANENT) {
        return merchantLocalStorage;
    }
    if (scope === StorageScope.TAB) {
        return merchantSessionStorage;
    }
    return memoryStorage;
}
